import React from 'react'
import { useTranslation } from 'react-i18next'
import { Input } from '@components'
import { FieldErrors, UseFormRegister } from 'react-hook-form'
import { IPaymentDetails } from '@query'
import styled from 'styled-components'

interface PaymentDetailsSectionProps {
  register: UseFormRegister<IPaymentDetails>
  errors: FieldErrors<IPaymentDetails>
}

export const PaymentDetailsSection: React.FC<PaymentDetailsSectionProps> = ({
  register,
  errors
}) => {
  const { t } = useTranslation()

  return (
    <Container>
      <Input
        type="number"
        step="0.01"
        label={t('containers.paymentFormModal.amount', { currency: 'EUR' })}
        required
        errors={errors.amount?.amount}
        {...register('amount.amount', {
          required: { value: true, message: t('validation.required') },
          valueAsNumber: true
        })}
      />
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
`
